import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const ARTICLES = [{
  title: 'Managing Seasonal Allergies',
  excerpt: 'Expert advice on identifying triggers and finding the right relief for your symptoms.'
}, {
  title: 'Heart Health Essentials',
  excerpt: 'Understanding blood pressure monitoring and heart-healthy lifestyle choices.'
}, {
  title: 'Immune System Support',
  excerpt: 'Practical tips for maintaining a strong immune system through nutrition and wellness.'
}];
export function AdviceSection() {
  return <section className="py-12 sm:py-24 bg-white" data-id="element-41" data-mp="28276fw3myeb2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42" data-mp="283ibdz8ths3r">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-slate-900 mb-8 sm:mb-12 text-center" data-id="element-43" data-mp="2c3se931bc2ee">
          Advice You Can Trust
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8" data-id="element-44" data-mp="u7t3htcklzfi">
          {ARTICLES.map((article, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-clean-grey p-6 sm:p-10 rounded-xl flex flex-col h-full" data-id="element-45" data-mp="18wfgvpin0h43" data-mpi={idx}>
              <div className="w-12 h-1 bg-clinical-blue mb-6 sm:mb-8" data-id="element-46" data-mp="l7whjzhkfeo5"></div>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-47" data-mp="21m5yw9ne435h">
                {article.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-8 flex-grow" data-id="element-48" data-mp="1wo4dvj6eltrd">
                {article.excerpt}
              </p>
              <Link to="/services" className="text-clinical-blue text-xs font-bold uppercase tracking-widest hover:underline" data-id="element-49" data-mp="23q9m05odfrj2">
                Read Article
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}